const TypeLettre = {
    1: 'Lettre simple',
    2: 'Lettre avec accusé de réception',
    3: 'Lettre recommandée électronique',
};

function TypeCommunication(type, mode) {
    switch (type) {
    case 0:
        return 'Document';
    case 1:
        return mode < 1 || mode > 3 ? 'Lettre' : TypeLettre[mode];
    default:
        return 'Inconnu';
    }
}

export default TypeCommunication;



// WEBPACK FOOTER //
// ./src/App_Data/TypeCommunication.js